import cn from 'classnames';

import s from './Attachment.module.scss';

const Attachment = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={cn(s.root, className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9796 3.6903C13.2233 1.43588 16.868 1.43777 19.1199 3.68874C21.375 5.93273 21.3729 9.57833 19.1209 11.8303L10.1409 20.8103C8.54797 22.4032 5.97311 22.4032 4.38022 20.8103C2.78732 19.2174 2.78732 16.6426 4.38022 15.0497L13.3802 6.04967C14.3231 5.10678 15.848 5.10678 16.7909 6.04967C17.7338 6.99256 17.7338 8.51743 16.7909 9.46032L10.1409 16.1103C9.84796 16.4032 9.37309 16.4032 9.0802 16.1103C8.7873 15.8174 8.78731 15.3426 9.0802 15.0497L15.7302 8.39966C16.0873 8.04255 16.0873 7.46744 15.7302 7.11033C15.3731 6.75322 14.798 6.75322 14.4409 7.11033L5.44088 16.1103C4.43377 17.1174 4.43377 18.7426 5.44088 19.7497C6.44798 20.7568 8.07309 20.7568 9.0802 19.7497L18.0602 10.7697C19.7281 9.10181 19.7261 6.40774 18.0616 4.75168L18.0602 4.75033C16.3924 3.08247 13.6983 3.08443 12.0422 4.74897L12.0409 4.75033L5.41088 11.3803C5.11799 11.6732 4.64311 11.6732 4.35022 11.3803C4.05732 11.0874 4.05732 10.6126 4.35022 10.3197L10.9789 3.69103C10.9791 3.69079 10.9793 3.69054 10.9796 3.6903Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { Attachment };
